import React from 'react';

import styles from './CompetitionsFeed.module.css';

type Props = {
  children: React.ReactNode;
};

export const CompetitionsFeedItems: React.FC<Props> = ({ children }) => (
  <div className={styles.CompetitionsFeed__Items}>{children}</div>
);
